import { ApiManager } from './apiManager';
import config from '../../config/config';

export default ApiManager({
  HTTPProfileManagerURL: config.PROFILE_MANAGER_API_BASE_URL,
  HTTPSubscriptionURL: config.SUBSCRIPTIONS_API_BASE_URL,
  HTTPBaseURL: config.API_BASE_URL,
  HTTPStorageURL: config.STORAGE_API_BASE_URL,
  HTTPDashboardURL: config.API_BASE_URL_DEFAULT,
});
